import Config from '../launch/config'
import {getHealthBarColor} from './utils'

export default function healthBar() {
    const ship = this
    const rect = ship.healthBarRect

    rect.setVisible(false)

    if (
        ship.faction === Config.userFactionName ||
        ship.isDetected ||
        Config.isDemo
    ) {
        let x = ship.x - ship.diameter + 10
        let y = ship.y - ship.diameter - 10

        if (ship.type === 'satellite') {
            x = ship.x - ship.diameter + 4
            y = ship.y - ship.diameter - 13
        }

        rect.setSize(ship.health / 4, 4)
        rect.setX(x)
        rect.setY(y)
        rect.setFillStyle(getHealthBarColor(ship.health))
        rect.setVisible(ship.health < Config.shipMaxHealth)
    }

    // Heal Ship
    if (ship.health < Config.shipMaxHealth) {
        const difficulty = Config.difficultyLevels[Config.difficulty]
        const rank = Config.shipRanks[`rank${ship.rank}`]
        const isUser = ship.faction === Config.userFactionName
        const isEnemy = ship.faction.includes(Config.enemyFactionName)

        let healRate = 0

        if (isUser) {
            healRate = rank.shipHealRate
        }

        if (isEnemy) {
            healRate = difficulty.enemyShipHealRate
        }

        if (ship.orbitingEntity) {
            if (
                isUser &&
                ship.orbitingEntity.faction === Config.userFactionName
            ) {
                healRate = rank.shipHealOrbitRate
            }

            if (
                isEnemy &&
                ship.orbitingEntity.faction?.includes(Config.enemyFactionName)
            ) {
                healRate = difficulty.enemyShipHealOrbitRate
            }
        }

        ship.health += healRate
    }
}
